/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
type CashbackEdit_cashback$ref = any;
type CashbackEdit_lists$ref = any;
export type CashbackEditQueryVariables = {|
  cashbackId: string
|};
export type CashbackEditQueryResponse = {|
  +cashback: ?{|
    +$fragmentRefs: CashbackEdit_cashback$ref
  |},
  +lists: ?{|
    +$fragmentRefs: CashbackEdit_lists$ref
  |},
|};
export type CashbackEditQuery = {|
  variables: CashbackEditQueryVariables,
  response: CashbackEditQueryResponse,
|};
*/


/*
query CashbackEditQuery(
  $cashbackId: ID!
) {
  cashback(id: $cashbackId) {
    ...CashbackEdit_cashback
    id
  }
  lists {
    ...CashbackEdit_lists
    id
  }
}

fragment CashbackEdit_cashback on Cashback {
  id
  date
  place
  storeId
  rate
  amount
}

fragment CashbackEdit_lists on Lists {
  stores(first: 1000, active: false) {
    edges {
      node {
        id
        name
      }
    }
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "cashbackId",
    "type": "ID!"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "id",
    "variableName": "cashbackId"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "CashbackEditQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "Cashback",
        "kind": "LinkedField",
        "name": "cashback",
        "plural": false,
        "selections": [
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "CashbackEdit_cashback"
          }
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "Lists",
        "kind": "LinkedField",
        "name": "lists",
        "plural": false,
        "selections": [
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "CashbackEdit_lists"
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "CashbackEditQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "Cashback",
        "kind": "LinkedField",
        "name": "cashback",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "date",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "place",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "storeId",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "rate",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "amount",
            "storageKey": null
          }
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "Lists",
        "kind": "LinkedField",
        "name": "lists",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": [
              {
                "kind": "Literal",
                "name": "active",
                "value": false
              },
              {
                "kind": "Literal",
                "name": "first",
                "value": 1000
              }
            ],
            "concreteType": "StoreConnection",
            "kind": "LinkedField",
            "name": "stores",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "StoreEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "Store",
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                      (v2/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "name",
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": "stores(active:false,first:1000)"
          },
          (v2/*: any*/)
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "id": null,
    "metadata": {},
    "name": "CashbackEditQuery",
    "operationKind": "query",
    "text": "query CashbackEditQuery(\n  $cashbackId: ID!\n) {\n  cashback(id: $cashbackId) {\n    ...CashbackEdit_cashback\n    id\n  }\n  lists {\n    ...CashbackEdit_lists\n    id\n  }\n}\n\nfragment CashbackEdit_cashback on Cashback {\n  id\n  date\n  place\n  storeId\n  rate\n  amount\n}\n\nfragment CashbackEdit_lists on Lists {\n  stores(first: 1000, active: false) {\n    edges {\n      node {\n        id\n        name\n      }\n    }\n  }\n}\n"
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = 'b7fcee3780a9c9a5758766cb6860ca53';

module.exports = node;
